import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'login', label: 'Login', icon: 'LogIn' },
    { id: 'register', label: 'Register', icon: 'UserPlus' }
  ];

  return (
    <div className="flex gap-2 p-1 bg-muted rounded-lg mb-6 md:mb-8">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md font-medium transition-all duration-250 min-h-[44px] ${
            activeTab === tab?.id
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'text-muted-foreground hover:text-foreground hover:bg-background'
          }`}
          aria-selected={activeTab === tab?.id}
          role="tab"
        >
          <Icon name={tab?.icon} size={18} />
          <span className="text-sm md:text-base">{tab?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;